import { gql } from '@apollo/client'
import type { TypedDocumentNode } from '@graphql-typed-document-node/core'

import { eventEditFragment } from '../fragments/EventEdit.fragment'

import type {
    EditEventQuery,
    EditEventQueryVariables,
} from './EventEdit.queries.generated'

export const GET_EVENT: TypedDocumentNode<
    EditEventQuery,
    EditEventQueryVariables
> = gql`
    query EditEvent($guid: String!) {
        entity(guid: $guid) {
            guid

            ...EventEdit
        }
    }
    ${eventEditFragment}
`
